module.exports = __webpack_public_path__ + "img/upload-icon.3242ac77.svg";